import { Table } from '@tanstack/react-table'
import { useTranslation } from 'react-i18next'

interface TablePageSizeProps<TData> {
    table: Table<TData>
    totalItems?: number
    className?: string
}

const TablePageSize = <TData,>(props: TablePageSizeProps<TData>) => {
    const { table, totalItems, className } = props

    const { t } = useTranslation()
    const displayedItems = table.getRowModel().rows.length

    if (!displayedItems && !totalItems)
        return (
            <span className={className} style={{ visibility: 'hidden' }}>
                &nbsp;
            </span>
        )

    return (
        <span className={className} style={{ color: '#8F99A3' }}>
            {t('table.resultsDisplayed', { displayedItems, totalItems: totalItems ?? displayedItems })}
        </span>
    )
}

export default TablePageSize
